
import React,{useState} from "react";


import { ArrowLeftOutlined, ArrowRightOutlined } from "@material-ui/icons";
import styled from "styled-components";
import { sliderItems } from "./Data"
import { mobile } from "../pages/Responsive";
import {
    // BrowserRouter as Router,
    
    Link
    
  }from "react-router-dom";


const Container=styled.div`
    width: 100%;
    height:100vh;
    display:flex;
    /* background-color: coral; */
    position: relative;
    overflow:hidden;
     ${mobile({height:"80vh"})} 
`
const Arrow=styled.div`
    width: 50px;
    height: 50px;
    background-color:#fff7f7;
    border-radius: 50%;
    display: flex;
    align-items:center;
    justify-content: center;
    position: absolute;
    top:0;
    bottom:0;
    left:${props=>  props.direction ==="left" &&  "10px"};
    
    right:${props=> props.direction ==="right" &&  "10px"};
    cursor: pointer;
    margin : auto;
    opacity: 0.5;
    z-index:2;

`
const Wrapper=styled.div`
    display: flex;
    height:100%;
    transition: all 1s ease;
    transform: translateX(${props=>props.slideIndex*-100}vw);
    

`
const Slide=styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    background-color: #${props=>props.bg};
`
const ImgContainer=styled.div`
    height: 100%;

    flex:1; 
    position: relative;
    display: flex;
    /* align-items: center; */
    justify-content: center;
    
    /* background-color: brown; */
    
    
   
    /* ${mobile({})}    */
`
const Circle=styled.div`
    position: absolute;
   
    margin-top:70px;
    background-color: #cccccc;
    width: 380px;
    height: 380px;
    border-radius: 50%;
    ${mobile({display: "none"})}

`

  
const Image=styled.img`
    /* z-index:2; */
    height: 80%;
    /* position: absolute; */
    z-index:2;
    ${mobile({marginRight: "10%"})}
        
` 
const InfoContainer=styled.div`
    flex:1;
    padding: 50px;
`

const Title=styled.h1`
    font-size    : 70px;
    ${mobile({display: "none"})}

`
const Desc=styled.p`
    margin: 50px 0px;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 3px;
    ${mobile({display: "none"})}
`
const Button=styled.button`
    padding: 10px;
    font-size: 20px;
    background-color: transparent;
    cursor: pointer;
`

const Slider=()=>{
        const [slideIndex, setSlideIndex] = useState(0)
    const handleClick=(direction)=>{
        if(direction==="left"){
            setSlideIndex(slideIndex>0 ? slideIndex-1 : 2)
        }
        else{
            setSlideIndex(slideIndex<2 ? slideIndex+1 : 0)
        }
    };
    return (
        <Container>
            <Arrow direction="left" onClick={()=>handleClick("left")}>
                <ArrowLeftOutlined></ArrowLeftOutlined>
            </Arrow>
                <Wrapper slideIndex={slideIndex}>
                    {sliderItems.map((item)=>(
                        <Slide bg={item.bg}>
                            <ImgContainer>
                                <Circle/>
                                <Image src={item.img}/>
                                
                            </ImgContainer>
                            <InfoContainer>
                                <Title> {item.title}</Title>
                                <Desc>{item.desc}</Desc>


                                <Link to={`/products/id`}  style={{textDecoration:"none",color:"black"}}>    <Button>Show now</Button></Link>
                            </InfoContainer>
                        </Slide>
                    ))
                }
                        
                </Wrapper>
            <Arrow direction ="right" onClick={()=>handleClick("right")}>
                <ArrowRightOutlined></ArrowRightOutlined>
            </Arrow>

        </Container>
    )
}
export default Slider